// extracted by mini-css-extract-plugin
module.exports = {"root":"WishlistPage_root__pffwr"};